module.exports = __webpack_public_path__ + "img/fi-talous.babef9c1.png";